<ng-template let-label="label" let-data="data" let-type="type" let-disabledAdd="disabledAdd" #rowTemplate>
    <div class="control-box f-row f-between">
        <span class="label">{{ label | translate }}</span>

        <div class="f-row input-box">
            <button class="input-box__minus" type="button" [disabled]="!data" (click)="changeAmount(type,-1)">
                <span>-</span>
            </button>
            <div class="input-box__value" [class.input-box__value--disabled]="!data">
                {{ data }}
            </div>
            <button class="input-box__plus" type="button" [disabled]="disabledAdd" (click)="changeAmount(type, 1)">
              <span>+</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-container
        *ngTemplateOutlet="rowTemplate; context: {label: 'ADULTS', data: adultsAmount, type: boxType.ADULTS}"
></ng-container>

<ng-container
        *ngTemplateOutlet="rowTemplate; context: {label: 'CHILDREN', data: childrenAmount, type: boxType.CHILDREN, disabledAdd: childrenAmount === roomsAmount * 3}"
></ng-container>

@if (childrenAmount) {
    <div class="f-row f-wrap f-between">
        @for (child of ages; track index; let index = $index) {
            <div class="input-box col-half">
                <mat-select [value]="child" (selectionChange)="selectionChange($event, index)">
                    @for (option of childOptions; track option.value) {
                        <mat-option [value]="option.value">{{ option.label }}</mat-option>
                    }
                </mat-select>
            </div>
        }
    </div>
}

@if (childrenAmount === roomsAmount * 3) {
  <div class="notify-error">
    To add children add rooms
  </div>
}

<ng-container
        *ngTemplateOutlet="rowTemplate; context: {label: 'ROOMS', data: roomsAmount, type: boxType.ROOMS}"
></ng-container>
